 export default function ErrorAlert({ error, onRetry, isLoading = false }) {
  if (!error) return null;

  return (
    <div className="tw-alert tw-alert-error tw-mb-4">
      <span>{typeof error === 'string' ? error : error.message || 'An error occurred'}</span>
      {onRetry && (
        <button
          className="tw-btn tw-btn-sm tw-btn-outline"
          onClick={onRetry}
          disabled={isLoading}
        >
          Retry
        </button>
      )}
    </div>
  );
}